import React, { useState, useContext, useEffect } from "react";
import Sidebar from "../../widgets/sidebar";
import Header from "../../widgets/header";
import noData from "../../assets/img/nodata-img.svg";
import { AllContext } from "../../context";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../components/pageLoader";
import LoadingOverlay from "react-loading-overlay";
import * as _ from "lodash";
import openIcon from "../../assets/img/icons/openSide.svg";
import sortIcon from "../../assets/img/icons/sortIcon.svg";
import serviceImg from "../../assets/img/serviceImg.svg";

import PaginationNewUI from "../../components/PaginationNewUI";
import DeleteConfirmModal from "../../components/DeleteConfirmModal";
LoadingOverlay.propTypes = undefined;

const Services = () => {
  const dispatch = useDispatch();
  const [toggleSideBar, setToggleSidebar] = React.useState(false);
  const handleSidebar = () => {
    setToggleSidebar(!toggleSideBar);
  };
  const context = useContext(AllContext);
  const {
    allApiUrl,
    apiPostMethod,
    apiDeleteMethod,
    toastMessage,
    redirectToLogin,
  } = context;
  const loginUserAccessToken = useSelector(
    (state) => state.loginReducer.loginUserAccessToken
  );
  const { currency } = useSelector(
    (state) => state.sideMenuReducer.paymentSettingData
  );
  const [services, setServices] = useState([]);
  const [bulkDeleteId, setBulkDeleteId] = React.useState([]);
  const [serviceId, setServiceId] = useState();
  const [serviceName, setServiceName] = useState();
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState(0);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0); // totalRecords
  const [itemOffset, setItemOffset] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false)
  const editService = async (_id) => {
    navigate("/edit-service/" + _id);
  };
  const businessId = useSelector(
    (state) => state.loginReducer.loginUserInfo.businessId
  );

  function deleteService(serviceId) {
    setIsLoading(true);
    setDisabledBtn(true)
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    apiDeleteMethod(allApiUrl.SERVICES, serviceId, header)
      .then((res) => {
        getAllServices();
        setIsLoading(false);
        setDisabledBtn(false)
        setIsDeleteConfirmModalOpen(false)
      })
      .catch((err) => {
        redirectToLogin(dispatch, navigate, err);
        setIsLoading(false);
        toastMessage("error", err.data.message);
        setDisabledBtn(false)
        setIsDeleteConfirmModalOpen(false)
      });
  }
  function getAllServices() {
    if (!initialLoading) {
      setIsLoading(true);
    }
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    let data = {};
    data.page = itemOffset;
    data.limit = itemsPerPage;
    data.businessId = businessId;
    apiPostMethod(allApiUrl.FILTER_SERVICES, data, header)
      .then((res) => {
        setPageCount(res.data.totalPage);
        setTotalRecordsCount(res.data.totalItems);
        setServices([...res.data.services]);
        setInitialLoading(false);
        setIsLoading(false);
      })
      .catch((err) => {
        redirectToLogin(dispatch, navigate, err);
        toastMessage("error", err.data.message);
        setInitialLoading(false);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getAllServices();
  }, [itemOffset, itemsPerPage]);

  function deleteMultiple() {
    setIsLoading(true);
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    apiPostMethod(allApiUrl.DELETE_SERVICES_BULK, { ids: bulkDeleteId }, header)
      .then((res) => {
        setBulkDeleteId([...[]]);
        toastMessage("error", res.data.message);
        getAllServices();
        setIsLoading(false);
      })
      .catch((err) => {
        redirectToLogin(dispatch, navigate, err);
        toastMessage("error", err.data.message);
        setIsLoading(false);
      });
  }

  function checkedAll() {
    if (services.length === bulkDeleteId.length) {
      setBulkDeleteId([...[]]);
    } else {
      let ids = services.map((e) => {
        return e._id;
      });
      setBulkDeleteId([...ids]);
    }
  }

  const onChangeCheckbox = (id, val) => {
    if (val) {
      bulkDeleteId.push(id);
      setBulkDeleteId([..._.uniq(bulkDeleteId)]);
    } else {
      _.remove(bulkDeleteId, (o) => o === id);
      setBulkDeleteId([...bulkDeleteId]);
    }
  };
  function selectOption(selected) {
    setSelectedOption(selected.target.value);
  }

  return (
    <div>
      <Sidebar
        activePage="services"
        setToggleSidebar={setToggleSidebar}
        toggleSideBar={toggleSideBar}
      />
      <Header handleSidebar={handleSidebar} />
      <PageLoader isLoading={initialLoading} />
      <div className="commonSlidePl">
        <div className="orders-section commonPadding dashboardTop">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5 col-12">
                <div className="heading position-relative">
                  <h2 className="mb-0">
                    Services <span className="userCounter">&nbsp;</span>
                    <a
                      onClick={() =>
                        navigate("/add-service", {
                          state: {
                            page: "service",
                          },
                        })
                      }
                      className="btn btn-addOrder"
                    >
                      Add Service
                    </a>
                  </h2>
                  <span
                    className="openArrowIcon"
                    onClick={() => {
                      setToggleSidebar(!toggleSideBar);
                    }}
                  >
                    <img src={openIcon} />
                  </span>
                </div>
              </div>

              <PaginationNewUI
                itemsPerPage={itemsPerPage}
                itemOffset={itemOffset}
                setItemOffset={setItemOffset}
                pageCount={pageCount}
                totalRecordsCount={totalRecordsCount}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
        {!initialLoading && (
          <div className="orders-section commonPadding horizontalPadding">
            <div className="container-fluid">
              <div className="row"></div>

              <LoadingOverlay
                styles={{
                  spinner: (base) => ({
                    ...base,
                    width: "50px",
                    "& svg circle": {
                      stroke: "#007D87",
                    },
                  }),
                  overlay: (base) => ({
                    ...base,
                    background: "rgba(255, 255, 255, 0.5)",
                  }),
                }}
                active={isLoading}
                spinner
                text="Loading content..."
              >
                <div className="row">
                  <div className="col-lg-12">
                    <div className="common-table clients-table mt-3 files-table rounded-1">
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="ps-4 w65-px">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="item1"
                                  checked={
                                    services.length === bulkDeleteId.length &&
                                    services.length > 0
                                  }
                                  onChange={() => checkedAll()}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="item1"
                                ></label>
                              </div>
                            </th>
                            <th>
                              Name{" "}
                              <span>
                                {" "}
                                <img src={sortIcon} />
                              </span>
                            </th>
                            <th>
                              Description
                              <span>
                                {" "}
                                <img src={sortIcon} />
                              </span>
                            </th>
                            <th>
                              PRICE
                              <span>
                                {" "}
                                <img src={sortIcon} />
                              </span>
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* no record found */}
                          {/* <tr>
                      <td colSpan={7}>
                        <div className="noData-section">
                          <img src={noData} />
                          <p>No Data Found</p>
                        </div>
                      </td>
                    </tr> */}
                          {/* no record found */}
                          {services.map((value, idx) => {
                            return (
                              <tr key={idx}>
                                <td className="ps-4 w65-px">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={value._id}
                                      checked={
                                        !!_.includes(bulkDeleteId, value._id)
                                      }
                                      onChange={(e) => {
                                        onChangeCheckbox(
                                          value._id,
                                          e.target.checked
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={value._id}
                                    ></label>
                                  </div>
                                </td>
                                <td>
                                  <a onClick={() => editService(value._id)}>
                                    <img
                                      className="servicenameImg"
                                      src={serviceImg}
                                    />
                                    {value.name}
                                  </a>
                                </td>
                                {/* <td>{value.description}</td> */}
                                <td>
                                  {" "}
                                  <div
                                    className="serviceDescription"
                                    dangerouslySetInnerHTML={{
                                      __html: value.description,
                                    }}
                                  ></div>
                                </td>

                                <td>
                                  <span>
                                    {currency?.symbol ? currency?.symbol : "$"}
                                    {value.price}
                                  </span>
                                </td>
                                <td className="text-end pe-4">
                                  <div className="dropdown">
                                    <button
                                      className="btn btn-secondary dropdown-toggle btn-info"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li>
                                        <a
                                          className="dropdown-item"
                                          href="#"
                                          onClick={() => editService(value._id)}
                                        >
                                          Edit
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          className="dropdown-item"
                                          href="#"
                                          onClick={() => {
                                            setServiceId(value._id);
                                            setServiceName(value.name);
                                            setIsDeleteConfirmModalOpen(true)
                                          }}
                                        >
                                          Delete
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                          {services && services.length <= 0 && (
                            <tr>
                              <td colSpan={7}>
                                <div className="noData-section">
                                  <img src={noData} />
                                  <p>No Data Found</p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {bulkDeleteId.length > 0 && (
                      <div className="table-bottom-option">
                        <div className="row">
                          <div className="col-lg-3 col-md-4">
                            <div className="input-group">
                              <select
                                id="selectOption"
                                value={selectOption.target}
                                onChange={(e) => selectOption(e)}
                                className="form-control"
                              >
                                <option value="">With Selected...</option>
                                <option value="Delete">Delete</option>
                              </select>
                              <button
                                className="btn btn-apply"
                                onClick={() => {
                                  if (selectedOption === "Delete") {
                                    deleteMultiple();
                                  }
                                }}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </LoadingOverlay>
            </div>
          </div>
        )}

        {isDeleteConfirmModalOpen ? (
          <DeleteConfirmModal
            isDeleteConfirmModalOpen={isDeleteConfirmModalOpen}
            handleDelete={() => { deleteService(serviceId) }}
            handleCancelModal={() => { setIsDeleteConfirmModalOpen(false) }}
            modalContent={`Are you sure you want to delete this service: ${serviceName}`}
            disabledBtn={disabledBtn}
          />
        ) : (
          ""
        )}

        <div
          className="modal fade add-order-modals"
          id="importModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Import services
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="add-order-form">
                  <form>
                    <div className="form-group">
                      <label>Select a csv file to import</label>
                      <div className="upload-file">
                        <i className="fa-solid fa-file-arrow-up"></i>
                        <p>
                          <span>Upload a file</span> or drag and drop
                        </p>
                        <input className="inputfile" type="file" />
                      </div>
                      <small>
                        Download the{" "}
                        <a target="_blank" href="#">
                          import template here.
                        </a>
                      </small>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary close-btn"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Preview
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Services;
